/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { postData, getData } from "utils/Gateway";

import MeetingReasonOptions from "Data/MeetingReason.json";
import MeetingReasonResponseOptions from "Data/MeetingReasonResponse.json";

const ReviewFeedbackModal = ({
  reviewType,
  moduleName,
  moduleId,
  meetingReason,
  onModalClose,
}) => {
  const token = localStorage.getItem("token");

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const starCount = [1, 2, 3, 4, 5];

  const [meetingReasonType, setMeetingReasonType] = useState("");
  const [selectedMeetingResponse, setSelectedMeetingResponse] = useState("");

  // initial useState to save the comment
  const [comments, setComments] = useState("");
  const [pointsOfDiscussion, setPointsOfDiscussion] = useState("");

  // initial useState to save star rating
  const [starRating, setstarRating] = useState("1");

  /* ------------ Initial useStates for activating the starts starts here ------------ */

  const [ratingError, setRatingError] = useState(false);
  const [commentError, setCommentError] = useState(false);
  const [isReviewPosting, setIsReviewPosting] = useState(false);

  const meetingReasonRadioHandler = (event) => {
    setSelectedMeetingResponse(event.target.value);
  };

  //select star rating
  const starRatingHandler = (value) => {
    setstarRating(value);
  };

  //get review details
  const getReviewDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_REVIEW_DETAILS +
        `?token=${token}&moduleslug=${moduleName}`;

      if (moduleName == "user") {
        requestUrl += `&expertid=${moduleId}`;
      } else {
      }

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status && response.data) {
        starRatingHandler(response.data.rating);
        setComments(response.data.comment);
        setPointsOfDiscussion(response.data.pointsofdiscussion);

        for (let meetingReasonResponse of MeetingReasonResponseOptions) {
          if (
            meetingReasonResponse.value.toString() ===
            response.data.meetingreasonresponse.toString()
          ) {
            setSelectedMeetingResponse(meetingReasonResponse.value.toString());
          }
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // Function to submit the review to the API.
  const reviewSubmitHandler = async () => {
    try {
      setIsReviewPosting(true);

      let requestURL =
        url.API_BASE_URL +
        url.API_GIVE_REVIEW +
        `?token=${token}&moduleslug=${moduleName}`;

      let reviewData = {
        comment: comments,
        rating: starRating,
        pointsofdiscussion: pointsOfDiscussion,
        meetingreason: meetingReasonType,
        meetingreasonresponse: selectedMeetingResponse,
      };

      switch (moduleName) {
        case "user":
          reviewData.expertid = moduleId;
          break;
        case "agenda":
          reviewData.agendaid = moduleId;
          break;
        case "event":
          reviewData.eventid = moduleId;
          break;
        default:
          console.log("Module not found");
          break;
      }

      console.log(reviewData);

      const response = await postData(requestURL, reviewData);

      setIsReviewPosting(false);
      console.log(response);

      if (response.status) {
        resetHandler();

        //hide modal
        let reviewModal = document.querySelector("#feedback_modal");
        let modal = bootstrap.Modal.getInstance(reviewModal);
        modal.hide();

        //display success modal
        let reviewSuccessModal = new bootstrap.Modal(
          document.getElementById("submit_feedback")
        );
        reviewSuccessModal.show();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  // function to reset the star and comments
  const resetHandler = () => {
    setComments("");
    setstarRating("1");
    onModalClose();
  };

  useEffect(() => {
    if (moduleId) {
      getReviewDetails();
      if (reviewType === "user") {
        for (let meetingReasonData of MeetingReasonOptions) {
          if (meetingReasonData.value.toString() === meetingReason.toString()) {
            setMeetingReasonType(meetingReasonData.value.toString());
          }
        }
      }
    }
  }, [moduleId]);

  return (
    <div className="feedback_modal">
      <div className="conatct_modal">
        <div
          className="modal fade"
          id="feedback_modal"
          data-bs-backdrop="static"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              {/* modal header */}
              <div className="modal-header">
                <div className="owner_hdngOuter d-flex align-items-center justify-content-between w-100 px-3">
                  <h3 className="text-primary text-uppercase fs-lg">
                    Feedback
                  </h3>
                  <button
                    type="button"
                    className="close rounded-circle"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={resetHandler}
                  >
                    <i className="material-icons-outlined text-black">close</i>
                  </button>
                </div>
              </div>

              {/* modal body */}
              <div className="modal-body">
                <div className="feedback_innr_pnl px-3">
                  {/* meeting options section */}
                  {reviewType === "user" &&
                  meetingReasonType !== "" &&
                  meetingReasonType !== "notsure" ? (
                    <>
                      <div className="form-group mb-4">
                        <label className="fw-bold mb-3 text-black fs-md">
                          Can it be your {meetingReasonType}?
                        </label>
                        {/* select meeting reason response  */}
                        <ul className="list_style_none checkbx_listing d-flex align-items-center gap-4">
                          {MeetingReasonResponseOptions.map((option, index) => {
                            return (
                              <li className="mb-0" key={index}>
                                <label className="radio-check">
                                  <input
                                    type="radio"
                                    name={option.label}
                                    value={option.value}
                                    checked={
                                      selectedMeetingResponse === option.value
                                    }
                                    onChange={meetingReasonRadioHandler}
                                  />
                                  <span></span>
                                  <p className="fs-sm text-primary">
                                    {option.label}
                                  </p>
                                </label>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </>
                  ) : null}

                  {/* star rating */}
                  <div className="form-group mb-4">
                    <label className="fw-bold mb-3 text-black fs-md">
                      Rate on a scale of 1 to 5
                    </label>

                    <ul className="list_style_none rating_star d-flex align-items-center">
                      {starCount.map((star, index) => (
                        <li
                          key={index}
                          className={
                            star.toString() <= starRating.toString()
                              ? "active"
                              : ""
                          }
                        >
                          <Link
                            to="#"
                            onClick={() => starRatingHandler(star.toString())}
                          >
                            <span className="material-icons">star</span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* points of discussed */}
                  {reviewType == "user" ? (
                    <div className="form-group description_fill mb-4">
                      <label className="fw-bold mb-3 text-black fs-md">
                        Points discussed
                      </label>
                      <textarea
                        className="form-control bg_white"
                        placeholder="Enter points"
                        value={pointsOfDiscussion}
                        onChange={(e) => {
                          setPointsOfDiscussion(e.target.value);
                        }}
                      ></textarea>
                    </div>
                  ) : null}

                  {/* comment/Next steps section */}
                  <div className="form-group description_fill mb-4">
                    <label className="fw-bold mb-3 text-black fs-md">
                      {reviewType === "user" ? "Next steps" : "Comments"}
                    </label>
                    <textarea
                      className="form-control bg_white"
                      placeholder="Enter comments"
                      value={comments}
                      onChange={(e) => setComments(e.target.value)}
                    ></textarea>
                  </div>

                  {/* submit button */}
                  <div className="form-group">
                    <button
                      className="btn primary-btn w-100"
                      style={{
                        cursor: isReviewPosting ? "not-allowed" : "pointer",
                      }}
                      disabled={isReviewPosting ? true : false}
                      onClick={reviewSubmitHandler}
                    >
                      Give Feedback
                      {isReviewPosting && (
                        <div
                          className="mx-2 spinner-border spinner-border-sm"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewFeedbackModal;
